import React from "react";
import { HeartHandshake, Accessibility, Baby, Home } from "lucide-react";

/**
 * Support commitments for women/youth, disabled buyers, elderly returnees.
 * Displayed on Home + Countries.
 */
export default function InclusionBand() {
  const items = [
    { i: <HeartHandshake size={22}/>, t: "Women & Youth First", d: "Equal ownership rights. Extra guidance and reduced fees for first-time buyers under 35." },
    { i: <Accessibility size={22}/>,  t: "Disability access",   d: "Accessible homes and plots flagged clearly. Extra help completing your application." },
    { i: <Baby size={22}/>,           t: "Buy for a child",     d: "Register your child as heir or joint owner directly on the deed — no extra fees." },
    { i: <Home size={22}/>,           t: "Elderly & Returnees", d: "Simplified process for seniors and long-term diaspora coming home. WhatsApp support in your language." },
  ];
  return (
    <section className="py-14 md:py-20 border-t mv-hairline" data-testid="inclusion-band">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="mv-eyebrow"><span style={{ color: "var(--mv-gold)" }}>§ Inclusion promise</span></div>
        <h2 className="font-display text-3xl md:text-5xl mv-green-text mt-3 leading-[1.05]">
          Every citizen. <span className="font-accent italic" style={{ color: "var(--mv-gold)" }}>Same fair terms.</span>
        </h2>
        <p className="mt-4 max-w-2xl text-[15px]" style={{ color: "var(--mv-muted)" }}>
          MAVULA supports equal ownership rights — no extra hurdles for women, young buyers, elderly returnees, or people with disabilities.
        </p>
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((c) => (
            <div key={c.t} className="mv-card p-6" data-testid={`inclusion-${c.t.split(" ")[0].toLowerCase()}`}>
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-2xl flex items-center justify-center mv-green-text" style={{ background: "rgba(212,175,55,0.16)" }}>{c.i}</div>
                <div className="font-display text-lg mv-green-text">{c.t}</div>
              </div>
              <p className="text-[14px]" style={{ color: "var(--mv-muted)" }}>{c.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
